// -----------------------------------------------------------------------------
// Constants
// -----------------------------------------------------------------------------

export const NAME = 'dfbInput'
const CLASS = 'dfb-Input'

export const ClassName = {
  ROOT: CLASS,
  ROOT_SUBMIT: `${CLASS}--submit`,
  ROOT_SEARCH: `${CLASS}--search`,
  ROOT_ERRORVISIBILITY: `${CLASS}--visibility`,
  FIELD: `${CLASS}-field`,
  LABEL: `${CLASS}-label`,
  INPUT: `${CLASS}-input`,
  SUBMIT: `${CLASS}-submit`,
  RESET: `${CLASS}-reset`,
  ERRORMESSAGE: `${CLASS}-errorMessage`
}
export const Selector = {
  ROOT: `.${ClassName.ROOT}`,
  ROOT_SUBMIT: `.${ClassName.ROOT_SUBMIT}`,
  ROOT_SEARCH: `.${ClassName.ROOT_SEARCH}`,
  ROOT_ERRORVISIBILITY: `.${ClassName.ROOT_ERRORVISIBILITY}`,
  FIELD: `.${ClassName.FIELD}`,
  LABEL: `.${ClassName.LABEL}`,
  INPUT: `.${ClassName.INPUT}`,
  SUBMIT: `.${ClassName.SUBMIT}`,
  RESET: `.${ClassName.RESET}`,
  ERRORMESSAGE: `.${ClassName.ERRORMESSAGE}`
}

export const States = {
  FOCUSED: `is-focused`,
  DISABLED: `is-disabled`,
  INVALID: `is-invalid`,
  VISIBLE: `is-visible`
}

export const Event = {
  CLICK: `click`,
  FOCUS: `focus`,
  FOCUSOUT: `focusout`,
  INPUT: `input`,
  DFB_INPUT: `${NAME}:input`,
  DFB_FOCUS: `${NAME}:focus`,
  DFB_FOCUSOUT: `${NAME}:focusout`,
  DFB_STATECHANGE: `${NAME}:stateChange`
}
